export interface City {
  id?: string;
  state?: string;
}
